import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-admin-table-actions',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink, ButtonModule],
  templateUrl: './admin-table-actions.component.html',
  styleUrl: './admin-table-actions.component.scss',
})
export class AdminTableActionsComponent {
  @Input() manageLabelKey = 'COMMON.MANAGE';
  @Input() deleteLabelKey = 'COMMON.DELETE';
  @Input() showManage = true;
  @Input() showDelete = true;
  @Input() manageDisabled = false;
  @Input() manageLoading = false;
  @Input() deleteDisabled = false;
  @Input() manageRouterLink: string | any[] | null = null;
  @Input() manageQueryParams: Record<string, string | number | boolean> | null = null;
  @Input() compact = false;

  @Output() manage = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
}
